<div class="label-basic">
  <question-text [displayText]="displayText" [inputClass]="inputClass" [componentId]="componentId"></question-text>
</div>
